// extracted by mini-css-extract-plugin
export default {"deals":"Deals_deals__uv5jA","light":"Deals_light__QZn37","dark":"Deals_dark__FZBUZ","top":"Deals_top__75GGD","bottom":"Deals_bottom__NaYfr"};